import React from 'react';
import { View } from 'react-native-web';
import { useRoute } from '@react-navigation/native';
import * as Animatable from 'react-native-animatable';

// Custom Components
import ProposalTab from '../ProfileMenu/tab_proposals';
import { NavBar } from '../../components';

// Configs
import GLOBAL from '../../configs/config_global';
import { STATE_KEYS, useGlobalState } from '../../configs/config_state';

// Navigation
import * as RootNavigation from '../../navigation/RootNavigation';

export function CateringDetailsProposal() {
    const { cateringData, onProposalTabRequested } = useRoute()?.params || {};

    // region Global States
    const [inScreenModalShowing] = useGlobalState(STATE_KEYS.IN_SCREEN_MODAL_SHOWING);
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ width: '100%', flex: 1, backgroundColor: GLOBAL.COLOR.MAIN_BACKGROUND }}>
            {/* Nav Bar */}
            <View style={{ width: '100%' }}>
                <NavBar
                    title={'Saved Proposals'}
                    subTitle={`${cateringData?.['occasion']} - ${cateringData?.['name']} | Tap to review and send`}
                    leftButtonIconName={'keyboard-arrow-left'}
                    leftButtonIconSize={40}
                />

                {/* In-Screen Modal Backdrop */}
                <Animatable.View
                    pointerEvents={inScreenModalShowing ? 'auto' : 'none'}
                    animation={inScreenModalShowing ? 'fadeIn' : 'fadeOut'}
                    duration={400}
                    style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
                />
            </View>

            {/* Proposal List */}
            <ProposalTab
                cateringData={cateringData}
                onCloseRequested={() => RootNavigation.goBack()}
                onProposalTabRequested={onProposalTabRequested}
            />
        </View>
    );
    // endregion
}
